module.exports = __webpack_public_path__ + "static/05-bbe6104ab5f4733e3a112f0a3fd0e4f4.png";